var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "219.9px",
    height: "175px",
    viewBox: "0 0 219.9 175",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#ffffff",
    d: "M218.1,106.2c-30.3-30.3-60.7-60.7-91-91c-4.4-4.4-8.7-8.7-13.1-13.1c0,2.8,0,5.7,0,8.5c0.1-0.1,0.2-0.2,0.4-0.4 c5.5-5.5-3-14-8.5-8.5c-30.3,30.3-60.7,60.7-91,91c-4.4,4.4-8.7,8.7-13.1,13.1c-5.5,5.5,3,14,8.5,8.5c30.3-30.3,60.7-60.7,91-91 c4.4-4.4,8.7-8.7,13.1-13.1c-2.8-2.8-5.7-5.7-8.5-8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-2.3,2.3-2.3,6.2,0,8.5c30.3,30.3,60.7,60.7,91,91 c4.4,4.4,8.7,8.7,13.1,13.1C215.1,120.2,223.6,111.7,218.1,106.2L218.1,106.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#ffffff",
    d: "M218.1,164.7c-30.3-30.3-60.7-60.7-91-91c-4.4-4.4-8.7-8.7-13.1-13.1c0,2.8,0,5.7,0,8.5c0.1-0.1,0.2-0.2,0.4-0.4 c5.5-5.5-3-14-8.5-8.5c-30.3,30.3-60.7,60.7-91,91c-4.4,4.4-8.7,8.7-13.1,13.1c-5.5,5.5,3,14,8.5,8.5c30.3-30.3,60.7-60.7,91-91 c4.4-4.4,8.7-8.7,13.1-13.1c-2.8-2.8-5.7-5.7-8.5-8.5c-0.1,0.1-0.2,0.2-0.4,0.4c-2.3,2.3-2.3,6.2,0,8.5c30.3,30.3,60.7,60.7,91,91 c4.4,4.4,8.7,8.7,13.1,13.1C215.1,178.7,223.6,170.2,218.1,164.7L218.1,164.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.5b6606b80506f50838d4c018d9169f6e.svg";
export { ForwardRef as ReactComponent };